import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    // Redirect to login page, saving the attempted location
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Check if user needs 2FA verification
  const needs2FA = sessionStorage.getItem('needs2FAVerification') === 'true';
  const is2FAPage = location.pathname === '/auth/two-steps';

  if (needs2FA && !is2FAPage) {
    // User is logged in but needs 2FA verification
    return <Navigate to="/auth/two-steps" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
